import React from 'react';

const ManageOrder = () => {
    return (
        <div>
            
        </div>
    );
};

export default ManageOrder;